import React from 'react'

import classNames from 'clsx'
import { omit } from 'ramda'

import { ButtonBase } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { annotationTypes } from '~/src/Annotations/constants'
import { EMPTY_ARRAY, useFilestackURL } from '~/src/Lib/Utils'

import { defaultProps, getContent, propTypes } from './utils'

export * from './utils'

const buttonStyles = { width: '100%', textAlign: 'left' }

const displayName = 'Annotations/BaseFormatter'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
  },
  tooltip: {},
  inlineRoot: {
    display: 'inline-flex',
  },
  title: {
    flex: '0 0 100%',
  },
  body: {
    flex: '0 0 100%',
    textAlign: 'left',
  },
  date: {
    flex: '1 2 50%',
    textAlign: 'left',
    width: '50%',
    paddingRight: theme.spacing(0.5),
    '$tooltip &': {
      width: '100%',
      flexBasis: '100%',
    }
  },
  location: {
    flex: '1 1 50%',
    textAlign: 'right',
    width: '50%'
  },
  user: {},
  avatar: {
    background: theme.palette.contrast.enabled,
    color: theme.palette.gray,
  },
}), { name: displayName })

const passThruOmitter = omit([
  ...Object.keys(propTypes),
  'Wrapper',
  'tooltip',
  'transparentCard',
])

export const BaseAnnotationFormatter = props => {
  const classes = useStyles(props)
  const content = getContent(classes, props)
  const {
    annotationKey,
    bare,
    inline,
    noButton,
    noDialogs,
    tooltip,
    Wrapper,
    className,
    ...restProps
  } = props
  if (bare) {
    return content
  }
  if (Wrapper) {
    return <Wrapper {...props}>{content}</Wrapper>
  }
  const rootClassName = classNames({
    [classes.root]: true,
    [classes.inlineRoot]: inline,
    [classes.tooltip]: tooltip,
    [className]: Boolean(className),
  })
  if (noButton) {
    return (
      <div className={rootClassName}>{content}</div>
    )
  }
  return (
    <ButtonBase
      {...passThruOmitter(restProps)}
      className={rootClassName}
      component={noDialogs ? 'div' : 'a'}
      data-testid={`annotation-tooltip-${annotationKey}`}
      href={noDialogs ? undefined : `#/${annotationKey.replace('_', '/')}`}
      style={buttonStyles}
    >
      {content}
    </ButtonBase>
  )
}

BaseAnnotationFormatter.propTypes = propTypes
BaseAnnotationFormatter.defaultProps = defaultProps
BaseAnnotationFormatter.displayName = displayName

const Memoized = React.memo(props => {
  const [annotationSchema] = props.annotationKey?.split('_') ?? EMPTY_ARRAY
  const annotationType = annotationTypes.find(({ schema }) => schema === annotationSchema)
  const filestack = useFilestackURL()

  return <BaseAnnotationFormatter {...props} {...annotationType?.extraProps} filestack={filestack} />
})
export default Memoized
